import ColorFactory from "./ColorFactory";
import webase from "../app/model";

export default class BackgroundFactory {

    constructor () {
        this.colorFactory = new ColorFactory()
    }

    generateNeutralBackground(propertyName) {
        let backgrounds = {}
        let bg = this.createBackground(propertyName, 'zinc', '50', 'zinc', '700')
        backgrounds[propertyName] = bg
        return backgrounds
    }

    generateNeutralDarkBackground(propertyName) {
        let backgrounds = {}
        let bg = this.createBackground(propertyName, 'zinc', '700', 'zinc', '50')
        backgrounds[propertyName] = bg
        return backgrounds
    }

    createBackground2(bgColorObject, textColorObject, name='primary', type='solid') {
        return {
            name: name,
            type: type,
            bgColor: {...bgColorObject},
            color: {...textColorObject},
            bgColor2: {...bgColorObject}, // for gradient
            bgColor3: null, // for gradient
        }
    }

    /*
     * @color - a color object with name, shade and hex value
     */
    generateBackgrounds(color) {
        if(color.name === 'white' || color.name === 'black' || color.name === 'transparent') {
            return this.simpleLightBackgrounds()
        }

        let backgrounds = {}
        let shade = Number(color.shade)
        let contrastShade = shade < 500 ? '800' : '100'

        // TODO: handle black or white
        let mainColor = this.colorFactory.createColorObject(color.name, color.shade)
        let contrastColor = this.colorFactory.createColorObject(color.name, contrastShade.toString())
        let lightColor = this.colorFactory.createColorObject(color.name, '50')

        backgrounds.primary = {
            name: 'primary',
            type: 'solid',
            bgColor: {...mainColor},
            color: {...contrastColor},
            bgColor2: {...mainColor}, // for gradient
            bgColor3: null, // for gradient
        }

        backgrounds.secondary = {
            name: 'secondary',
            type: 'solid',
            bgColor: {...lightColor},
            color: {...mainColor},
            bgColor2: {...lightColor}, // for gradient
            bgColor3: null, // for gradient
        }

        return backgrounds
    }

    simpleLightBackgrounds() {
        let backgrounds = {}
        let mainColor = this.colorFactory.createColorObject('white')
        let contrastColor = this.colorFactory.createColorObject('stone', '800')
        let lightColor = this.colorFactory.createColorObject('stone', '50')

        backgrounds.primary = {
            name: 'primary',
            type: 'solid',
            bgColor: {...mainColor},
            color: {...contrastColor},
            bgColor2: {...mainColor}, // for gradient
            bgColor3: null, // for gradient
        }

        backgrounds.secondary = {
            name: 'secondary',
            type: 'solid',
            bgColor: {...lightColor},
            color: {...contrastColor},
            bgColor2: {...lightColor}, // for gradient
            bgColor3: null, // for gradient
        }

        return backgrounds
    }

    simpleDarkBackgrounds() {
        let backgrounds = {}
        let mainColor = this.colorFactory.createColorObject('slate', '900')
        let contrastColor = this.colorFactory.createColorObject('white')
        let lightColor = this.colorFactory.createColorObject('slate', '800')

        backgrounds.primary = {
            name: 'primary',
            type: 'solid',
            bgColor: {...mainColor},
            color: {...contrastColor},
            bgColor2: {...mainColor}, // for gradient
            bgColor3: null, // for gradient
        }

        backgrounds.secondary = {
            name: 'secondary',
            type: 'solid',
            bgColor: {...lightColor},
            color: {...contrastColor},
            bgColor2: {...lightColor}, // for gradient
            bgColor3: null, // for gradient
        }

        return backgrounds
    }

    generateDarkBackgrounds(color) {
        if(color.name === 'white' || color.name === 'black' || color.name === 'transparent') {
            return this.simpleDarkBackgrounds()
        }

        let backgrounds = {}
        let themeColorShade = Number(color.shade)
        let lighterShade = themeColorShade - 100
        let mediumColor = this.colorFactory.createColorObject(color.name, lighterShade.toString())
        let darkestColor = this.colorFactory.createColorObject('slate', '800')
        let secondaryDark = this.colorFactory.createColorObject('slate', '700')

        backgrounds.primary = {
            name: 'primary',
            type: 'solid',
            bgColor: {...darkestColor},
            color: {...mediumColor},
            bgColor2: {...darkestColor}, // for gradient
            bgColor3: null, // for gradient
        }

        backgrounds.secondary = {
            name: 'secondary',
            type: 'solid',
            bgColor: {...secondaryDark},
            color: {...mediumColor},
            bgColor2: {...secondaryDark}, // for gradient
            bgColor3: null, // for gradient
        }

        return backgrounds
    }

    updateBackgroundColor(background, color) {
        background.bgColor = this.colorFactory.createColorObject(color.name, color.shade)

        if(color.name === 'black') {
            background.color = this.colorFactory.createColorObject('slate', 100)
            return
        } else if(color.name === 'white') {
            background.color = this.colorFactory.createColorObject('slate', 800)
            return
        }

        let contrastShade = color.shade < 500 ? 900 : 50
        background.color = this.colorFactory.createColorObject(color.name, contrastShade)
    }

    createDefaultBackground(name, bgColor, textColor) {
        return {
            name: name,
            type: 'solid',
            bgColor:  this.colorFactory.createColorObject(bgColor),
            color: this.colorFactory.createColorObject(textColor),
            bgColor2: null, // for gradient
            bgColor3: null, // for gradient
        }
    }

    generateDarkerButton(background) {
        let colorName = background.bgColor.name
        let shade = Number(background.bgColor.shade) + 200
        let hoverShade = Number(background.bgColor.shade) + 300
        return [`bg-${colorName}-${shade}`, `text-${colorName}-50`, `hover:bg-${colorName}-${hoverShade}`]
    }

    generateLighterButton(background) {
        let colorName = background.bgColor.name
        let shade = 100
        let hoverShade = 50
        return [`bg-${colorName}-${shade}`, `text-${colorName}-900`, `hover:bg-${colorName}-${hoverShade}`]
    }

    createBackground(name, bgColor, bgShade, textColor, textShade) {
        return {
            name: name,
            type: 'solid',
            bgColor:  this.colorFactory.createColorObject(bgColor, bgShade),
            color: this.colorFactory.createColorObject(textColor, textShade),
            bgColor2: this.colorFactory.createColorObject(bgColor, bgShade), // for gradient
            bgColor3: null, // for gradient
        }
    }

    cssClasses2(background) {
        let classes = []

        if(background.background.name === 'white') {
            classes.push('bg-white')
        }
        else if(background.background.name === 'black') {
            classes.push('bg-black')
        }
        else if(background.background.name === 'transparent') {
            classes.push('bg-transparent')
        }
        else {
            classes.push(`bg-${background.background.name}-${background.background.shade}`)
        }

        if(background.text.name === 'white') {
            classes.push('text-white')
        }
        else if(background.text.name === 'black') {
            classes.push('text-black')
        }
        else if(background.text.name === 'transparent') {
            classes.push('text-transparent')
        }
        else {
            classes.push(`text-${background.text.name}-${background.text.shade}`)
        }

        return classes
    }

    cssClasses(background, prefix='') {
        // console.log('BG Fact cssClasses ----------------------------------------------')
        // console.log(background)
        let classes = []
        const styleUtil = webase.utils.styleManager.getStyleUtil()
        classes.push(styleUtil.toColorClass(background.color, `${prefix}text`))

        if(background.type === 'solid') {
            classes.push(styleUtil.toColorClass(background.bgColor, `${prefix}bg`))
            return classes
        }

        classes.push(`${prefix}bg-gradient-to-r`)
        classes.push(styleUtil.toColorClass(background.bgColor, `${prefix}from`))

        if(background.bgColor3) {
            classes.push(styleUtil.toColorClass(background.bgColor2, `${prefix}via`))
            classes.push(styleUtil.toColorClass(background.bgColor3, `${prefix}to`))
        }
        else {
            classes.push(styleUtil.toColorClass(background.bgColor2, `${prefix}to`))
        }

        return classes
    }
}